import { css } from "@emotion/react";
import { colorTokens } from "theme/theme";

export const rootStyle = css`
  background: #000000;
  border-radius: 6px;
  border: none;
  color: ${colorTokens.colors["text.primary"].dark};
  cursor: pointer;
  width: 100%;
  &:disabled {
    background-color: #c2c2c2;
    cursor: not-allowed;
  }
`;
